import React, { useMemo } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function toISODate(value) {
  if (!value) return "";

  return String(value).slice(0, 10);
}

export default function DialogIncentivoResultadoDetalhe({
  PaperComponent,
  open,
  onClose,
  titulo,
  data,
  loading,
}) {
  const columns = useMemo(
    () => [
      {
        Header: "Data",
        accessor: "faturadata",
        width: 110,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Fatura",
        accessor: "faturanumero",
        width: 130,
      },
      {
        Header: "Cliente",
        accessor: "cliente",
        width: 260,
      },
      {
        Header: "Material",
        accessor: "material",
        width: 320,
      },
      {
        Header: "Qtd",
        accessor: "qtd",
        width: 90,
      },
      {
        Header: "€ Líquido",
        accessor: "precoliquido",
        width: 110,
      },
      {
        Header: "1ª Compra",
        accessor: "primeira_compra",
        width: 110,
        Cell: ({ value }) => (Number(value || 0) === 1 ? "✓" : ""),
      },
      {
        Header: "Entra benefício",
        accessor: "entra_beneficio",
        width: 130,
        Cell: ({ value }) => (Number(value || 0) === 1 ? "✓" : ""),
      },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", xl: "1450px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        Detalhe do resultado
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <MDTypography variant="caption" color="text" display="block" mb={1}>
          {titulo}
        </MDTypography>

        <ProjectTable
          tableKey="incentivos-resultados-detalhe"
          version="v1"
          columns={columns}
          data={Array.isArray(data) ? data : []}
          loading={loading}
          minWidth={1260}
          maxHeight="58vh"
          emptyMessage="Sem faturas para apresentar."
          actionsPosition="left"
        />
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
